// extracted by mini-css-extract-plugin
export default {"list":"cv_hS","listItem":"cv_km","icon":"cv_js","text":"cv_cZ","title":"cv_cX","description":"cv_c"};